import {html} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import B2bElement from '../../../../b2b-element.js';
import B2bPublicServiceClientProxy
  from '../../../../gen/com/arabellesolutions/sdc/b2b/pub/B2bPublicServiceClientProxy.js';
import defaultStyle from '../../../b2b-public-styles.scss';

@customElement('b2b-public-email')
export class B2bPublicEmail extends B2bElement {
  static styles = [defaultStyle];

  /** @type {String} */
  @state()
  accessor __code = {
    code: ''
  };

  __b2bPublicServiceProxy = new B2bPublicServiceClientProxy(super.msgpackClientPublic());

  /**
   * @param {String} entry
   * @return {Promise<boolean>}
   */
  __submit = entry => this.__b2bPublicServiceProxy.verifyUserByCode(entry.code);

  render() {
    return html`
      <mta-page-title page-name="email" title="Email Verification"></mta-page-title>
      <div class="page-container">
        <mta-form
            .value="${this.__code}"
            @success="${this.__submitted}"
            @keydown="${this.__onKeyDown}"
            success-message="Your account has been verified successfully">
          <div class="menu-top-left">
            <common-mta-logo class="logo" url=""></common-mta-logo>
          </div>
          <div class="form-header">
            <h2>Verify Your Email Address</h2>
              <p>Kindly check your email and enter the code provided below.</p>
              <p>Please note that the code will expire within 12 hours.</p>
          </div>
          <div class="line">
            <mta-form-input name="code" label="Enter the 8-digit code" required></mta-form-input>
          </div>
          <mta-form-buttons hide-cancel="true" submit-label="Submit" .submit="${this.__submit}"></mta-form-buttons>
        </mta-form>
      </div>
    `;
  }

  __submitted() {
    this.redirect('#/auth/login');
  }

  connectedCallback() {
    super.connectedCallback();
    if (!this.__submit) {
      this.redirect('#/auth/registration');
    }
  }

  __onKeyDown(e) {
    if (e.keyCode === 13) {
      const form = this.shadowRoot.querySelector("mta-form");
      const buttons = this.shadowRoot.querySelector("mta-form-buttons");

      form.resetStateHistory();
      buttons.submit(this.__code).then(() => this.__submitted());
    }
  }
}
